var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatarBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 27.5,
    fill: "white",
    stroke: "#EDEDF3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9246 31.2367C29.7537 31.2367 31.2365 29.7539 31.2365 27.9249C31.2365 26.0958 29.7537 24.613 27.9246 24.613C26.0955 24.613 24.6128 26.0958 24.6128 27.9249C24.6128 29.7539 26.0955 31.2367 27.9246 31.2367Z",
    fill: "#F43030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 14C20.268 14 14 20.268 14 28C14 32.6005 16.2191 36.6824 19.6452 39.2344V27.9247C19.6452 23.352 23.352 19.6452 27.9247 19.6452C31.3195 19.6452 34.2356 21.6892 35.5134 24.6129H41.5865C40.0719 18.5176 34.5639 14 28 14Z",
    fill: "#262532"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7616 32.5913C33.2708 34.7721 30.7657 36.2042 27.9246 36.2042C26.7468 36.2042 25.6272 35.9567 24.6128 35.5133V41.5864C25.6975 41.856 26.8318 41.9999 27.9999 41.9999C32.9021 41.9999 37.2117 39.478 39.7117 35.6628L34.7616 32.5913Z",
    fill: "#262532"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5136 24.613H32.7422V31.2367H35.5136H35.9209L41.5868 24.613H35.5136Z",
    fill: "#0085FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.5865,
    height: 28,
    fill: "white",
    transform: "translate(14 14)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarBlue);
export default __webpack_public_path__ + "static/media/avatar-blue.754d501dd36512c088624529d5923f25.svg";
export { ForwardRef as ReactComponent };